import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { MaskLine } from "./Reveal";

export default function PageHero({ image, eyebrow, title, sub, crumb, children }) {
  return (
    <section className="relative flex min-h-[52vh] flex-col justify-end overflow-hidden bg-tosca-900 pb-12 pt-36 md:min-h-[56vh] md:pb-16">
      <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/45 to-black/40" />
      <div className="container-x relative z-10">
        <nav className="flex items-center gap-1.5 text-xs text-white/60" aria-label="Breadcrumb">
          <Link to="/" className="transition hover:text-gold">Home</Link>
          {crumb && (
            <>
              <ChevronRight className="h-3 w-3" />
              <span className="text-gold">{crumb}</span>
            </>
          )}
        </nav>
        {eyebrow && <p className="mt-5 text-xs font-bold uppercase tracking-[0.25em] text-gold">{eyebrow}</p>}
        <h1 className="mt-3 max-w-3xl font-heading text-3xl font-extrabold tracking-tight text-white sm:text-5xl md:text-6xl">
          <MaskLine delay={0.2}>{title}</MaskLine>
        </h1>
        {sub && (
          <MaskLine delay={0.4}>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-white/80 sm:text-base">{sub}</p>
          </MaskLine>
        )}
        {children && <div className="mt-7 flex flex-col gap-3 sm:flex-row">{children}</div>}
      </div>
    </section>
  );
}
